import { gql } from 'apollo-boost';

export const RESEND_WELCOME_EMAIL = gql`
query resendWelcomeEmail($email: String!) {
    resendWelcomeEmail(email: $email)
}
`;